import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
  Outlet,
} from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './theme';
import './App.css';

// Pages
import Home from './pages/Home';
import Places from './pages/Places';
import Events from './pages/Events';
import EventsEmbed from './pages/EventsEmbed';
import EventsCalendar from './pages/EventsCalendar';
import EventsWidget from './pages/EventsWidget';
import CalendarEmbed from './pages/CalendarEmbed';
import CategoriesEmbed from './pages/CategoriesEmbed';
import PlacesEmbed from './pages/PlacesEmbed';
import Kiosk from './pages/Kiosk';
import Tours from './pages/Tours';
import AppDownload from './pages/AppDownload';
import SubmitSomething from './pages/SubmitSomething';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import CategoriesAdmin from './pages/CategoriesAdmin';
import AdminDashboard from './pages/AdminDashboard';
import PlacesAdmin from './pages/PlacesAdmin';
import EventsAdmin from './pages/EventsAdmin';
import RelatedEventsAdmin from './pages/RelatedEventsAdmin';
import ToursAdmin from './pages/ToursAdmin';
import TourStopsAdmin from './pages/TourStopsAdmin';
import UsersAdmin from './pages/UsersAdmin';
import BillingAdmin from './pages/BillingAdmin';
import DocsAdmin from './pages/DocsAdmin';
import ContactsAdmin from './pages/ContactsAdmin';
import ContactPage from './pages/ContactPage';
import ProjectsAdmin from './pages/ProjectsAdmin';
import ProjectPage from './pages/ProjectPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import Analytics from './pages/Analytics';
import Privacy from './pages/Privacy';

function AppLayout() {
  return (
    <Layout className="App">
      <Layout.Content className="main">
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={
          <ConfigProvider theme={theme}>
            <AppLayout />
          </ConfigProvider>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/places" element={<Places />} />
        <Route path="/events" element={<Events />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="/events/embed" element={<EventsEmbed />} />
        <Route path="/events/calendar" element={<EventsCalendar />} />
        <Route path="/events/widget" element={<EventsWidget />} />
        <Route path="/calendar/embed" element={<CalendarEmbed />} />
        <Route path="/categories/embed" element={<CategoriesEmbed />} />
        <Route path="/places/embed" element={<PlacesEmbed />} />
        <Route path="/kiosk" element={<Kiosk />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/app" element={<AppDownload />} />
        <Route path="/app/download" element={<AppDownload />} />
        <Route path="/submit" element={<SubmitSomething />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="categories" element={<CategoriesAdmin />} />
          <Route path="places" element={<PlacesAdmin />} />
          <Route path="events" element={<EventsAdmin />} />
          <Route path="events/:eventName/related" element={<RelatedEventsAdmin />} />
          <Route path="tours" element={<ToursAdmin />} />
          <Route path="tours/:tourId/stops" element={<TourStopsAdmin />} />
          <Route path="billing" element={<BillingAdmin />} />
          <Route path="docs" element={<DocsAdmin />} />
          <Route path="users" element={<UsersAdmin />} />
          <Route path="contacts" element={<ContactsAdmin />} />
          <Route path="contacts/new" element={<ContactPage />} />
          <Route path="contacts/:id" element={<ContactPage />} />
          <Route path="projects" element={<ProjectsAdmin />} />
          <Route path="projects/new" element={<ProjectPage />} />
          <Route path="projects/:id" element={<ProjectPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="analytics" element={<Analytics />} />
        </Route>
      </Route>
    )
  );

  return <RouterProvider router={router} />;
}

export default App;
